// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/sailing5.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
  background: #343434;
  font-family: sans-serif;
}

.header-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  filter: grayscale(100%);
  background-size: cover;
  background-attachment: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0%;
}

.header-bg h2 {
  margin: 0;
  padding: 0;
  font-size: 5em;
  background: #fff;
  color: #000;
  padding: 20px;
  text-align: center;
  max-width: 80%;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.5);

}

a,
a:active,
a:hover {
  text-decoration: none;
  color: white;
  outline: 0;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,mDAAwC;EACxC,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,0CAA0C;;AAE5C;;AAEA;;;EAGE,qBAAqB;EACrB,YAAY;EACZ,UAAU;AACZ","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  background: #343434;\n  font-family: sans-serif;\n}\n\n.header-bg {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  background: url('./assets/sailing5.png');\n  filter: grayscale(100%);\n  background-size: cover;\n  background-attachment: fixed;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0%;\n}\n\n.header-bg h2 {\n  margin: 0;\n  padding: 0;\n  font-size: 5em;\n  background: #fff;\n  color: #000;\n  padding: 20px;\n  text-align: center;\n  max-width: 80%;\n  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.5);\n\n}\n\na,\na:active,\na:hover {\n  text-decoration: none;\n  color: white;\n  outline: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
